import { Button, Drawer } from "antd";
import "./ConfirmationModal.scss";

interface PriorityConfirmationModalProps {
  open: boolean;
  mode: "mark" | "revert";
  toteId: string;
  trolleyId?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const PriorityConfirmationModal = ({
  open,
  mode,
  toteId,
  trolleyId,
  onConfirm,
  onCancel,
  isLoading = false,
}: PriorityConfirmationModalProps) => {
  const isMarkingHigh = mode === "mark";
  const message = isMarkingHigh
    ? `You’re changing tote (ID: ${toteId}) status to High Priority. ${
        trolleyId
          ? `The associated Trolley (ID: ${trolleyId}) will also be marked as High Priority to ensure aligned handling.`
          : "Any associated trolley will also be marked as High Priority to ensure aligned handling."
      }`
    : `You’re reverting tote (ID: ${toteId}) status to Standard. If no other high-priority totes remain${
        trolleyId ? ` on Trolley (ID: ${trolleyId})` : ""
      }, the trolley will also revert to Standard handling.`;

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      className="confirmation-drawer"
      placement="bottom"
      closable={false}
      mask={true}
      destroyOnClose
      height="auto"
    >
      <div className="confirmation-content">
        <h2 className="confirmation-title">Priority Confirmation</h2>
        <p className="confirmation-subtitle">{message}</p>

        <div className="modal-actions">
          <Button onClick={onCancel} className="cancel-button">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="confirm-button"
            loading={isLoading}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default PriorityConfirmationModal;


